import { render } from "./ManageKbArticleListView.vue?vue&type=template&id=434f7f09"
import script from "./ManageKbArticleListView.vue?vue&type=script&lang=js"
export * from "./ManageKbArticleListView.vue?vue&type=script&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "E:\\my project backsups\\vue\\vuestyle3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__